var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport } from "vue";
var _hoisted_1 = ["aria-describedby"];
var _hoisted_2 = { key: 0 };
var _hoisted_3 = { key: 1 };
var _hoisted_4 = { key: 2 };
import { computed, ref } from "vue";
import { uniqueId } from "lodash-es";
import Tooltip from "../../../components/Tooltip.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HintTooltip',
    props: {
        classPrefix: String,
        teleport: Object,
        buttonClass: String,
        message: String,
        inline: Boolean,
        tester: Boolean,
        refill: Boolean,
        sample: Boolean,
    },
    setup: function (__props) {
        var props = __props;
        var id = uniqueId('tooltip-');
        var button = ref();
        var classes = computed(function () { return [props.inline ? 'tooltip-wrapper--inline' : null, props.classPrefix]; });
        var buttonClass = computed(function () { return [props.classPrefix ? "".concat(props.classPrefix, "-btn") : null, props.buttonClass]; });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["tooltip-wrapper", classes.value])
            }, [
                _renderSlot(_ctx.$slots, "default"),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("button", {
                    class: _normalizeClass(["tooltip-btn", buttonClass.value]),
                    "aria-describedby": _unref(id),
                    type: "button",
                    ref_key: "button",
                    ref: button
                }, _toDisplayString(__props.message), 11 /* TEXT, CLASS, PROPS */, _hoisted_1),
                _cache[6] || (_cache[6] = _createTextVNode()),
                (_openBlock(), _createBlock(_Teleport, {
                    to: __props.teleport,
                    disabled: !__props.teleport
                }, [
                    (__props.tester || __props.sample || __props.refill)
                        ? (_openBlock(), _createBlock(Tooltip, {
                            key: 0,
                            button: button.value,
                            id: _unref(id)
                        }, {
                            default: _withCtx(function () { return [
                                (__props.tester)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, __spreadArray([], __read((_cache[0] || (_cache[0] = [
                                        _createElementVNode("strong", null, "Тестер", -1 /* CACHED */),
                                        _createTextVNode(" отличается от обычного флакона только оформлением. Как правило,\n          тестер без слюды или в простой коробке, для некоторых ароматов тестеры поставляются без крышек. Содержимое ничем не отличается\n          от\n          парфюма в обычной упаковке.\n        ", -1 /* CACHED */)
                                    ]))), false)))
                                    : _createCommentVNode("v-if", true),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                (__props.sample)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, __spreadArray([], __read((_cache[1] || (_cache[1] = [
                                        _createElementVNode("strong", null, "Сэмплы", -1 /* CACHED */),
                                        _createTextVNode(" это оригинальные ароматы в маленьких объёмах.", -1 /* CACHED */),
                                        _createElementVNode("br", null, null, -1 /* CACHED */),
                                        _createTextVNode(" Преимущества сэмплов:", -1 /* CACHED */),
                                        _createElementVNode("br", null, null, -1 /* CACHED */),
                                        _createTextVNode("\n          · Отличная возможность недорого познакомиться с большим количеством селективной и элитной парфюмерии.", -1 /* CACHED */),
                                        _createElementVNode("br", null, null, -1 /* CACHED */),
                                        _createTextVNode("\n          · Сэмплы являются отличным вариантом для тех, кто любит смешивать несколько ароматов сразу, создавая собственный\n          уникальный парфюм.", -1 /* CACHED */),
                                        _createElementVNode("br", null, null, -1 /* CACHED */),
                                        _createTextVNode("\n          · Благодаря маленьким размерам, любимые ароматы всегда можно носить с собой в сумочке и при необходимости\n          обновлять.", -1 /* CACHED */),
                                        _createElementVNode("br", null, null, -1 /* CACHED */),
                                        _createTextVNode("\n          · Атомайзер может отличаться по цвету и дизайну от фотографии указанной на сайте.\n        ", -1 /* CACHED */)
                                    ]))), false)))
                                    : _createCommentVNode("v-if", true),
                                _cache[4] || (_cache[4] = _createTextVNode()),
                                (__props.refill)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, __spreadArray([], __read((_cache[2] || (_cache[2] = [
                                        _createElementVNode("strong", null, "Refill", -1 /* CACHED */),
                                        _createTextVNode(", или рефил — запасная емкость (запаска) с косметическим или парфюмерным продуктом. В парфюмерии\n          это флакон с оригинальной ароматической композицией в более простой упаковке, чаще всего без распылителя в виде\n          обычной бутылочки с крышкой. Ее содержимое нужно аккуратно перелить в основной флакон. Есть рефиллы со встроенным\n          распылителем. Тогда достаточно открутить крышку бутылочки и можно пользоваться, как обычными духами.\n        ", -1 /* CACHED */)
                                    ]))), false)))
                                    : _createCommentVNode("v-if", true)
                            ]; }),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["button", "id"]))
                        : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, ["to", "disabled"]))
            ], 2 /* CLASS */));
        };
    }
});
